/* ==========================================================================
   CASEMIRA · RÉASSURANCE EN PIED DE PAGE · LE MOUVEMENT
   Fichier : assets/casemira-reassurance-pied.js · 07/09/2026, chantier 7.

   Il fait deux choses, dans cet ordre, et l'ordre est tout :
   1. il DÉCLARE que la bande sera animée (`cmrp--anime`), ce qui autorise la
      feuille à poser l'état de départ ;
   2. il l'allume (`est-vu`) quand elle entre dans le champ, ce qui déclenche le
      tracé des six icônes et la cascade des six colonnes.

   L'état de départ n'est jamais posé par la feuille seule : si ce fichier ne
   part pas, la bande s'affiche telle quelle. Une bande de réassurance
   invisible parce qu'un script n'a pas répondu serait pire que pas d'animation
   du tout.

   POURQUOI PAS `IntersectionObserver`, ET C'EST UN RELEVÉ, PAS UN AVIS.
   Premier jet : un observateur. Sur téléphone, le pied de page mesure près de
   deux mille pixels ; un saut direct au bas du document (ancre, bouton « haut
   de page », restauration de position) fait passer la bande d'« au-dessous de
   l'écran » à « au-dessus de l'écran » ENTRE DEUX IMAGES. L'observateur ne
   voit aucune intersection, `est-vu` n'arrive jamais, et les six colonnes
   restent invisibles pour le reste de la visite. Constaté à 390 px le 07/09.
   Un écouteur de défilement, lui, RELIT la position : dès que le haut de la
   bande est passé sous la ligne des 92 % de la fenêtre, elle s'allume, qu'on
   soit arrivé là en glissant ou en sautant. Il est passif, cadencé par
   `requestAnimationFrame`, et il se retire dès que toutes les bandes sont
   allumées.

   POURQUOI PAS `animation-timeline: view()`, comme sur la home : la bande vit
   au-dessus du PIED de page, et sur une page courte elle est déjà visible au
   chargement, où une chronologie de défilement ne se déclencherait pas.

   POURQUOI PAS `casemira-home-motion.js` : il n'est chargé que sur la page
   d'accueil (`snippets/casemira-home-socle.liquid`), et il porte tout un
   vocabulaire dont cette bande n'a aucun usage.
   ========================================================================== */
(function () {
  'use strict';
  var moins = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function poser() {
    if (moins) return;
    var bandes = Array.prototype.slice.call(document.querySelectorAll('[data-cmrp]'));
    if (!bandes.length) return;

    /* Déjà dans la fenêtre au moment où le script parle : on ne l'anime pas.
       La cacher pour la rallumer une image plus tard donnerait un
       clignotement, et une entrée qu'on n'a pas vue entrer ne sert à rien. */
    bandes = bandes.filter(function (b) {
      var r = b.getBoundingClientRect();
      return r.top >= window.innerHeight;
    });
    if (!bandes.length) return;
    bandes.forEach(function (b) { b.classList.add('cmrp--anime'); });

    var enCours = false;
    function regarde() {
      enCours = false;
      var reste = [];
      bandes.forEach(function (b) {
        if (b.getBoundingClientRect().top < window.innerHeight * 0.92) b.classList.add('est-vu');
        else reste.push(b);
      });
      bandes = reste;
      if (!bandes.length) {
        window.removeEventListener('scroll', demande);
        window.removeEventListener('resize', demande);
      }
    }
    function demande() {
      if (enCours) return;
      enCours = true;
      window.requestAnimationFrame(regarde);
    }
    window.addEventListener('scroll', demande, { passive: true });
    window.addEventListener('resize', demande, { passive: true });
    demande();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser, { once: true });
  } else {
    poser();
  }
})();
